import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CreatePriceDto, Price, UpdatePriceDto } from '../models/price.model';

@Injectable({ providedIn: 'root' })
export class PricesService {
  private http = inject(HttpClient);
  private base = `${environment.apiUrl}/Prices`;

  getAll(): Observable<Price[]> {
    return this.http.get<Price[]>(this.base).pipe(catchError(this.handle));
  }

  getById(id: string): Observable<Price> {
    return this.http.get<Price>(`${this.base}/${id}`).pipe(catchError(this.handle));
  }

  create(dto: CreatePriceDto): Observable<Price> {
    return this.http.post<Price>(this.base, dto).pipe(catchError(this.handle));
  }

  update(id: string, dto: UpdatePriceDto): Observable<Price> {
    return this.http.put<Price>(`${this.base}/${id}`, dto).pipe(catchError(this.handle));
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.base}/${id}`).pipe(catchError(this.handle));
  }

  forClient(clientId: string): Observable<Price[]> {
    return this.http.get<Price[]>(`${this.base}/for-client/${clientId}`).pipe(catchError(this.handle));
  }

  private handle(err: any) {
    return throwError(() => err);
  }
}
